import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { isUserAgreementNotAcceptedError } from '$core/models/user-agreement-not-accepted-error';
import { isMaintenance } from '$core/helpers/is-maintenance';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // return next.handle(req);
    return next.handle(req).pipe(
      catchError((err) => {
        if (isUserAgreementNotAcceptedError(err)) {
          return throwError(err);
        }

        switch (err.status) {
          case 503:
            if (isMaintenance(err)) {
              const router = this.injector.get(Router);
              router.navigate(['/error', '503'], {
                replaceUrl: true,
                skipLocationChange: true,
              });
            }
            break;
          case 429:
            break;
        }
        return throwError(err);
      })
    );
  }
}
